<template lang='pug'>
  v-tooltip(bottom color='white')
    template(v-slot:activator='{on}')
      v-btn(v-on='on' text icon)
        v-icon desktop_windows
    div(v-for='(item, index) of environments', :key='index')
      v-chip.v-chip--select-multi(:key='index')
        img.image(:src='getBrowser(item.browser)')
        | {{item.browser | browser}}
</template>

<script>
import EnvironmentMixin from '../mixins/environment.mixin';

export default {
  name: 'BionicMetricsEnvironments',
  components: {},
  props: ['environments'],
  mounted() {
  },
  methods: {},
  mixins: [EnvironmentMixin],
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .image {
    margin: 2px;
    height: 20px;
    width: 20px;
  }
</style>
